// extracted by mini-css-extract-plugin
module.exports = {"taskProgress":"style_taskProgress__fa2sABfHh4SRzRnQ4gKje","disabled":"style_disabled__3HibV2d9i-lz_1lr4VBScX"};